/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const LocationIcon = createIcon({
  displayName: "LocationIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M13 6.75391C13 10.5153 8 13.9951 8 13.9951C8 13.9951 3 10.5153 3 6.75391C3 3.99248 5.23858 1.75391 8 1.75391C10.7614 1.75391 13 3.99248 13 6.75391Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <circle
        cx={8}
        cy={6.69238}
        r={1.94238}
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  )
});
